import { render } from "./PopupMassEditPrefs.vue?vue&type=template&id=36722e90"
import script from "./PopupMassEditPrefs.vue?vue&type=script&lang=js"
export * from "./PopupMassEditPrefs.vue?vue&type=script&lang=js"

import "./PopupMassEditPrefs.vue?vue&type=style&index=0&id=36722e90&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__